import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d7607be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "选择发票申请类型", -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "message-tips" }

import { ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'type-select',
  setup(__props) {

const activedVal = ref(0)
const list = [
  {
    title: '系统默认开票',
    tips: '将按发票抬头“个人”开具电子普通发票',
  },
  {
    title: '指定发票抬头',
    tips: '电子发票将通过短信发送',
  },
]

function confirmSelect() {
  console.log('456', 456)
  if (activedVal.value === 0) {
    // 系统默认开票
  } else if (activedVal.value === 1) {
    // 去到发票列表选择发票
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "发票申请" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
          return _createElementVNode("li", {
            key: index,
            class: _normalizeClass(activedVal.value === index ? 'actived' : ''),
            onClick: ($event: any) => (activedVal.value = index)
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.tips), 1)
          ], 10, _hoisted_4)
        }), 64))
      ])
    ]),
    _createVNode(CommonFooterNextButton, {
      title: "确定发票",
      onClick: confirmSelect,
      fullBtn: "",
      class: "confirm-button"
    })
  ], 64))
}
}

})